










































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { NetworkService } from '../../services/NetworkService'

export default Vue.extend({

  data() {
    return {
      previousPrice: '-' as (number | string),
      previousFrt: '-' as (number | string),
      loading: false as boolean
    }
  },
  props: ['selectedProduct'],
  computed: {
    ...mapGetters({
      make: 'makes/currentMake',
      dealerId: 'dealers/currentDealerId',
    }),
    obs () : any {
      return this.$refs.observer as any
    }
  },
  methods: {
    async updateManufacturerProduct() {
      const isValid = await this.obs.validate()
      if (isValid) {
        this.loading = true
        console.log(this.selectedProduct)
        const res : any = await NetworkService.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/auth/product_overrides/', { dealerId: this.dealerId, productId: this.selectedProduct.id, price: this.selectedProduct.dealerPrice, frt: this.selectedProduct.dealerFrt, featured: this.selectedProduct.featured})

        console.log(res)
        if (res.status === 200) {
          this.loading = false
          this.$emit('closeManufacturerDialog', true)
        } else {
          this.loading = false
          this.$emit('closeManufacturerDialog', false)
        }
        this.loading = false
      }
    },
    cancel() {
      this.selectedProduct.dealerPrice = this.previousPrice
      this.selectedProduct.dealerFrt = this.previousFrt
      this.previousPrice = '-'
      this.previousFrt = '-'
      this.$emit('closeManufacturerDialog', false)
    },
    async deleteOverride() {
      this.loading = true
      const res = await NetworkService.get(
        process.env.VUE_APP_API_BASE_URL +
          '/api/v1/auth/product_overrides/' + this.selectedProduct.id + '/' + this.dealerId
      )

      const overrideId = res.data[0].id

      await NetworkService.delete(
        process.env.VUE_APP_API_BASE_URL + 
        '/api/v1/auth/product_overrides/' + overrideId
      )

      this.loading = false
      this.$emit('closeManufacturerDialog', true)
    }
  },
  mounted() {
    this.previousPrice = this.selectedProduct.dealerPrice
    this.previousFrt = this.selectedProduct.dealerFrt
    console.log(this.selectedProduct)
  },
  components: {
  }
})
